<template>
  <div class="pb-4 text-h4">
    {{ text }}
  </div>
</template>
<script>
export default {
  name: "Title",
  props: {
    text: null
  }
}
</script>
